import { createGetAllApi } from "@api/util/createGetAllApi";

import type { IApiResponse, IPagination, IPaginationParams } from "@api";
import type { IResponseOption } from "@interfaces";

import type { IPathBaseParam } from "./path";
import type { IWarehouseCirculationEventKindsEnum } from "./types";

const getAllApis = createGetAllApi<
  IApiResponse<
    IPagination<IResponseOption<IWarehouseCirculationEventKindsEnum>>
  >,
  IPathBaseParam,
  IPaginationParams
>("selectTypes.warehouseCirculationEventKinds");

export const warehouseCirculationEventKinds = {
  ...getAllApis,
};
